import { onMounted, reactive } from 'vue';
// 引入获取首页轮播图数据的函数
import { getBanner } from "@/request/api/home";
export default {
  setup() {
    const state = reactive({
      images: []
    });
    onMounted(async () => {
      let res = await getBanner();
      state.images = res.data.banners;
    });
    return {
      state
    };
  }
};